import {
  type dtoSalesPartnerAddress,
  type dtoSalesPartnerData,
  type FeaturesType,
  type GoogleMarker,
  type SalesPartnerAddress,
} from "~/domains/salesPartner/types/SalesPartnerTypes";

export enum GLOBAL_POSITION {
  LAT_MIN = -90,
  LAT_MAX = 90,
  LONG_MIN = -180,
  LONG_MAX = 180,
}

function transformAddress(address: dtoSalesPartnerAddress, subsidiaryId: string): SalesPartnerAddress {
  return {
    id: address.id,
    companyNameDisplay: address.companyNameTransl ?? "",
    companyName: address.companyName ?? "",
    line1: address.line1 ?? "",
    line2: address.line2 ?? "",
    town: address.townName ?? "",
    postalCode: address.postalCode ?? "",
    phone: address.phone ?? "",
    fax: address.fax ?? "",
    email: address.email ?? "",
    country: {
      name: address.country?.name ?? "",
      isocode: address.country?.isocode ?? "",
    },
    website: address.website ?? "",
    salesPartnerId: subsidiaryId,
  };
}

export function markersTransformer(dto: dtoSalesPartnerData): GoogleMarker[] {
  const newGoogleMarkers: GoogleMarker[] = [];

  dto.results.forEach((result) => {
    const address = transformAddress(result.address, result.subsidiaryId);

    if (
      result.geoPoint.latitude > GLOBAL_POSITION.LAT_MIN &&
      result.geoPoint.latitude < GLOBAL_POSITION.LAT_MAX &&
      result.geoPoint.longitude > GLOBAL_POSITION.LONG_MIN &&
      result.geoPoint.longitude < GLOBAL_POSITION.LONG_MAX &&
      address.companyName !== "" &&
      address.companyNameDisplay !== ""
    ) {
      newGoogleMarkers.push({
        lat: result.geoPoint.latitude,
        lng: result.geoPoint.longitude,
        unicId: [
          result.geoPoint.latitude,
          result.geoPoint.longitude,
          result.address?.companyNameTransl,
          result.subsidiaryId,
        ]
          .filter(Boolean)
          .join("-"),
        address,
        features: result.features,
        displayName: result.displayName,
        formattedDistance: result.formattedDistance,
        affiliateId: result.affiliateId,
        subsidiaryId: result.subsidiaryId,
        subsidiaryName: result.name,
        certifiedCompetences: result.certifiedCompetences,
        productCompetences: result.productCompetences,
        certifiedDescriptionList: result.certifiedDescriptionList,
        logoUrl: result.logoUrl,
      });
    }
  });
  return newGoogleMarkers;
}

export enum SalesPartnerFeature {
  INA = "INA",
  FAG = "FAG",
}

export function containsFeature(features: FeaturesType, featureType: SalesPartnerFeature): boolean {
  return Object.keys(features).some((featureKey) => featureKey === featureType);
}
